import React from 'react';
import { Link } from 'react-router-dom';
import { IGetDishRestaurantProperties } from 'types';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './CategoryList.module.scss';

interface IProps {
	onClickShowAssignModal?: () => void;
	items: IGetDishRestaurantProperties['data']['categories'];
}

export const CategoryList: React.FC<IProps> = React.memo(({ onClickShowAssignModal, items }) => {
	return (
		<>
			<div className={style.list}>
				{items?.length ? (
					items.map((category) => (
						<div key={category.id} className={style.itemWrapper}>
							<div className={style.category}>
								<div className={style.dot} />
								<Link
									className={style.link}
									target={`blank_${Date.now()}`}
									rel="noopener noreferrer"
									to={`/menu-v2/category/edit?categoryID=${category.id}`}>
									<Text
										className={style.name}
										translationKey={category.name}
										size="s"
										withTooltip={true}
									/>
								</Link>
							</div>
							{!!category.subCategories?.length &&
								category.subCategories.map((subCategory) => (
									<div className={style.subcategory} key={subCategory.id}>
										<svg className={style.rectangleIcon}>
											<use xlinkHref={`${breadcrumbs}#rectangle`} />
										</svg>
										<Link
											className={style.link}
											target={`blank_${Date.now()}`}
											rel="noopener noreferrer"
											to={`/menu-v2/subcategory/edit?subcategoryID=${subCategory.id}`}>
											<Text
												className={style.name}
												translationKey={subCategory.name}
												size="s"
												withTooltip={true}
											/>
										</Link>
									</div>
								))}
						</div>
					))
				) : (
					<Text translationNameSpace="form" translationKey="-" />
				)}
			</div>
			{onClickShowAssignModal && (
				<Button
					className={style.editBtn}
					size="sizeS"
					theme="outlined"
					onClick={onClickShowAssignModal}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#pencil`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="editCategoryListButton" asFragment={true} />
				</Button>
			)}
		</>
	);
});
